"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var _visuallyHidden = require("@react-aria/visually-hidden");

var _styledQuantitySelectorModule = _interopRequireDefault(require("./styledQuantitySelector.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var QuantitySelector = function QuantitySelector(_ref) {
  var buttonType = _ref.buttonType,
      viewType = _ref.viewType,
      labelType = _ref.labelType,
      quantity = _ref.quantity,
      inc = _ref.inc,
      dec = _ref.dec,
      _ref$withAddButton = _ref.withAddButton,
      withAddButton = _ref$withAddButton === void 0 ? true : _ref$withAddButton,
      name = _ref.name;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _styledQuantitySelectorModule["default"].quantitySelector
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _styledQuantitySelectorModule["default"]["quantitySelector-container"]
  }, /*#__PURE__*/_react["default"].createElement(_.ThemeButton, {
    type: buttonType,
    className: _styledQuantitySelectorModule["default"]["quantity-btn"],
    onClick: dec
  }, "\u2013"), withAddButton ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.View, {
    type: viewType,
    className: _styledQuantitySelectorModule["default"]["quantity-content"]
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    "aria-live": "polite",
    type: labelType
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity)), /*#__PURE__*/_react["default"].createElement(_.ThemeButton, {
    type: buttonType,
    className: _styledQuantitySelectorModule["default"]["quantity-btn"],
    onClick: inc
  }, "+")) : /*#__PURE__*/_react["default"].createElement(_.View, {
    type: viewType,
    className: _styledQuantitySelectorModule["default"]["quantity-content"],
    onClick: inc
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    "aria-live": "polite",
    type: labelType
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity))));
};

var _default = QuantitySelector;
exports["default"] = _default;